import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SPECIALTIES } from '../models/specialties.model';

@Injectable({
  providedIn: 'root'
})
export class SpecialtiesService {

  constructor() { }

  getSpecialties(): Observable<string[]> {
    return of(SPECIALTIES);
  }
}
